<template>
    <div class="cardContainer">
        <van-row>
            <van-col span="24" class="dayRow">
                <van-row style="width: 100%;" justify="center">
                    <van-col span="4" v-for="(i, index) in dayList" :key="index">
                        <div class="dayCard">
                            <div class="dayImage">
                                <img v-if="index == 0 && showClickButton" src="@/assets/common/claim_available.png"
                                    alt="">
                                <img v-else src="@/assets/common/claim_not_available.png" alt="">
                                <span class="day-num" :class="{ 'day-num-disable': !(index == 0 && showClickButton) }">
                                    {{ index + 1 }}
                                </span>
                            </div>
                            <div class="dateText" style="color: #aeaeae;">
                                {{ dayFormat(i.date, 0) }}</div>
                            <div class="dateText" :class="{
                                'date-text-active': index === 0 && showClickButton,
                                'date-text-inactive': index === 0 && !showClickButton
                            }">
                                {{ formatCurrency(i.amount) }}
                            </div>
                        </div>
                    </van-col>
                </van-row>
            </van-col>
            <van-col span="24" class="availbleContent">
                <van-row style="margin: 5px 0 0;border-bottom: 1px solid #c19a6ba6;">
                    <van-col span="12" style="text-align: center;">
                        <div class="availableTitle" style="color: #d1bdac;">{{ $t('activity.available') }}: </div>
                        <div class="availableTitle glowText">{{ 'R$ ' + formatCurrency(availableValue) }}</div>
                    </van-col>
                    <van-col span="12" style="display: flex; justify-content: center; align-items: center;">
                        <div class="click_btn" :class="{ 'btn-disabled': !showClickButton }"
                            @click="showClickButton && clickOnButton()">
                            <span>{{ $t('activity.click') }}</span>
                        </div>
                    </van-col>
                </van-row>
                <div class="givenValueText">
                    {{ $t('activity.given') }}:
                    <span class="glowText">{{ formatCurrency(givenValue) }}</span>
                </div>
            </van-col>
        </van-row>
    </div>

</template>
<script lang="ts" setup>
import { dayFormat, formatCurrency, getDefaultRewards } from '@/utils/commonFunction';
import { PropType } from 'vue';

const props = defineProps({
    showClickButton: {
        type: Boolean,
    },
    availableValue: {
        type: Number,
        default: () => 0
    },
    givenValue: {
        type: Number,
        default: () => 0
    },
    dayList: {
        type: Array as PropType<(any)[]>,
        default: () => getDefaultRewards()
    },
    createDate: {
        type: String,
        default: () => ""
    },
})
const emits = defineEmits(['getClaim'])

const clickOnButton = () => {
    emits('getClaim')
}

</script>
<style scoped>
.cardContainer {
    background: linear-gradient(to bottom,
            #003534 0%,
            #003534 5%,
            #001a1a 85%,
            #000000 100%);
    box-shadow: inset 0 0 12px rgba(255, 105, 180, 0.15);
    border: 1px solid #c19a6b;
    border-radius: 10px;
    padding: 10px 15px;
    color: #fff;
    font-size: 12px;
    margin: 10px 15px 0;
}

.dayRow {
    display: flex;
    flex-direction: row;
}

.dayColumn {
    display: flex;
    flex-direction: column;
    justify-content: center;
    text-align: center;
    align-items: center;
    border-right: 3px dashed #80808070;
}

.availbleContent {
    justify-content: center;
    border: 1px solid #c19a6ba6;
    border-radius: 10px;
    background: #002121;
    margin-top: 10px;
}

.availableTitle {
    color: #ccbfb4;
    font-size: 16px;
}

.glowText {
    background: linear-gradient(to bottom, #e0b87e 0%, #a27e4b 100%);
    -webkit-background-clip: text;
    background-clip: text;
    color: transparent;
    font-family: 'Arial Black', sans-serif;
    font-weight: 900;
    filter: drop-shadow(2px 2px 1px rgba(0, 0, 0, 0.5));
    -webkit-font-smoothing: antialiased;
    font-size: 22px;
}

.day-num {
    position: absolute;
    font-size: 1rem;
    white-space: nowrap;
    color: #e1b75d;
    text-shadow: 0 0 10px #e1b75d, 0 0 20px #e1b75d;
    z-index: 800;
    font-weight: 600;
    left: 61%;
    bottom: 33%;
}

.day-num-disable {
    color: #5c5958;
    text-shadow: 0 0 10px #5c5958, 0 0 20px #5c5958;
}

.dateText {
    padding-top: 5px;
    font-size: 12px;
}

.dayImage img {
    width: 95%;
}

.dayImage {
    position: relative;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    margin-bottom: 5px;
}

.centerAlignment {
    display: flex;
    flex-direction: column;
    justify-content: center;
    text-align: center;
    align-items: center;
}

.dayCard {
    color: #fff;
    font-size: 9.5px;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    text-align: center;
    min-width: 13%;
    flex-shrink: 0;
    padding-top: 5px;
}

.dayCardWrapper {
    display: flex;
    overflow-x: auto;
    white-space: nowrap;
    scrollbar-width: none;
    -ms-overflow-style: none;
    flex: 1;
}

.dayCardWrapper::-webkit-scrollbar {
    display: none;
}

.scrollRow {
    display: flex;
    align-items: center;
    width: 100%;
    position: relative;
    gap: 5px;
}

.arrowLeft img {
    width: 10px;
}

.arrowRight {
    position: absolute;
    right: 0px;
}

.arrowLeft {
    position: absolute;
    left: 0px;
}

.arrowRight img {
    width: 10px;
    transform: rotate(180deg);
}

.dayTitle {
    font-weight: bold;
    padding-bottom: 5px;
}

.rightBorder {
    border-right: 1px solid #80808070;
}

.click_btn {
    font-size: 16px;
    background-color: #cf4747;
    font-family: 'Arial Black', sans-serif;
    padding: 5px 0;
    text-align: center;
    width: 80%;
    filter: drop-shadow(0 0 15px rgba(89, 45, 10, 0.3));
    text-shadow: 1px 1px 1px rgba(0, 0, 0, 0.4);
    border: 2px solid transparent;
    border-radius: 12px;
    background-image:
        linear-gradient(#121212, #121212),
        linear-gradient(to right, #614a2c, #dfba88, #614a2c);
    background-origin: border-box;
    background-clip: padding-box, border-box;
    color: #dfba88;
    box-shadow: 0 0 12px rgba(223, 186, 136, 0.3);
}

.click_btn.btn-disabled {
    cursor: not-allowed;
    color: #555555;
    text-shadow: none;
    background-image:
        linear-gradient(#1a1a1a, #1a1a1a),
        linear-gradient(to right, #333, #555, #333);
    box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.5);
    filter: grayscale(1) opacity(0.7);
}

.givenValueText {
    color: #d1bdac;
    padding: 1px;
    width: 100%;
    font-size: 16px;
    text-align: center;
}

.valueText {
    padding: 2px 0 5px;
}

.date-text-active {
    color: #e1b75d;
    text-shadow: 0 0 10px #e1b75d, 0 0 20px #e1b75d;
}

.date-text-inactive {
    color: #717070;
}
</style>